import { render, staticRenderFns } from "./PreguntaOpcio.vue?vue&type=template&id=e51e852e&"
import script from "./PreguntaOpcio.vue?vue&type=script&lang=js&"
export * from "./PreguntaOpcio.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaOpcio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports